"use strict";
// Copyright © Veeam Software Group GmbH
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WorkloadsDashboardWidget = void 0;
const react_1 = __importStar(require("react"));
const core_1 = require("@veeam/core");
const EC2_Instance32_svg_1 = __importDefault(require("../../../../assets/icons/dashboard/EC2_Instance32.svg"));
const RDS_Instance32_svg_1 = __importDefault(require("../../../../assets/icons/dashboard/RDS_Instance32.svg"));
const EFS32_svg_1 = __importDefault(require("../../../../assets/icons/dashboard/EFS32.svg"));
const Azure_virtual_machines32_svg_1 = __importDefault(require("../../../../assets/icons/dashboard/Azure_virtual_machines32.svg"));
const Azure_files32_svg_1 = __importDefault(require("../../../../assets/icons/dashboard/Azure_files32.svg"));
const Googl_virtual_machine32_svg_1 = __importDefault(require("../../../../assets/icons/dashboard/Googl_virtual_machine32.svg"));
const components_1 = require("../../../../components");
const core_2 = require("../../../../core");
const components_2 = require("../../components");
const types_1 = require("./types");
const WorkloadsInteractor_1 = require("./WorkloadsInteractor");
const components_3 = require("../../../../components/DashboardWidgets/components");
const helpers_1 = require("../../../../components/DashboardWidgets/helpers");
const constants_1 = require("../constants");
const WorkloadsDashboardWidget = ({ loadableModel, onRowClick, noDataTexts, }) => {
    const { t } = core_2.useFeatureContext();
    const { isAws, isAzure, isGcp } = core_2.useProductContext();
    const [periodModel] = react_1.useState(() => new components_2.PeriodModel());
    core_1.useInteractor(() => {
        return new WorkloadsInteractor_1.WorkloadsInteractor(loadableModel, periodModel, constants_1.WIDGET_NAMES.workloads);
    });
    const { value, meta: { loading: isLoading }, } = core_1.useModel(loadableModel);
    const { value: periodValue } = core_1.useModel(periodModel);
    let widgetData = [];
    if (isAws() && 'ec2InstancesCount' in value) {
        widgetData = [
            {
                icon: EC2_Instance32_svg_1.default,
                text: t('dashboard|protectedWorkloads|type|ec2'),
                type: types_1.WORKLOADS_WIDGET_AWS_ROW_TYPES.ec2Instances,
                value: value.ec2InstancesCount,
                total: value.ec2InstancesTotalCount,
            },
            {
                icon: RDS_Instance32_svg_1.default,
                text: t('dashboard|protectedWorkloads|type|rds'),
                type: types_1.WORKLOADS_WIDGET_AWS_ROW_TYPES.rdsInstances,
                value: value.rdsInstancesCount,
                total: value.rdsInstancesTotalCount,
            },
            {
                icon: EFS32_svg_1.default,
                text: t('dashboard|protectedWorkloads|type|efs'),
                type: types_1.WORKLOADS_WIDGET_AWS_ROW_TYPES.efsInstances,
                value: value.efsInstancesCount,
                total: value.efsInstancesTotalCount,
            },
        ];
    }
    if (isAzure() && 'azureSqlDatabasesCount' in value) {
        widgetData = [
            {
                icon: Azure_virtual_machines32_svg_1.default,
                text: t('dashboard|protectedWorkloads|type|virtualMachines'),
                type: types_1.WORKLOADS_WIDGET_AZURE_ROW_TYPES.virtualMachines,
                value: value.virtualMachinesCount,
                total: value.virtualMachinesTotalCount,
            },
            {
                icon: RDS_Instance32_svg_1.default,
                text: t('dashboard|protectedWorkloads|type|azureSqlDatabases'),
                type: types_1.WORKLOADS_WIDGET_AZURE_ROW_TYPES.azureSql,
                value: value.azureSqlDatabasesCount,
                total: value.azureSqlDatabasesTotalCount,
            },
            {
                icon: Azure_files32_svg_1.default,
                text: t('dashboard|protectedWorkloads|type|azureFiles'),
                type: types_1.WORKLOADS_WIDGET_AZURE_ROW_TYPES.azureFiles,
                value: value.azureFilesCount,
                total: value.azureFilesTotalCount,
            },
        ];
    }
    if (isGcp() && 'cloudSqlDatabasesCount' in value) {
        widgetData = [
            {
                icon: Googl_virtual_machine32_svg_1.default,
                text: t('dashboard|protectedWorkloads|type|virtualMachines'),
                type: types_1.WORKLOADS_WIDGET_GCP_ROW_TYPES.virtualMachines,
                value: value.virtualMachinesCount,
                total: value.virtualMachinesTotalCount,
            },
            {
                icon: RDS_Instance32_svg_1.default,
                text: t('dashboard|protectedWorkloads|type|cloudSqlDatabases'),
                type: types_1.WORKLOADS_WIDGET_GCP_ROW_TYPES.cloudSql,
                value: value.cloudSqlDatabasesCount,
                total: value.cloudSqlDatabasesTotalCount,
            },
        ];
    }
    return (react_1.default.createElement(components_1.DashboardPlate, { title: t('dashboard|protectedWorkloads|header'), headerAddon: !isLoading ? react_1.default.createElement(components_2.Period, { model: periodModel }) : undefined, content: react_1.default.createElement(components_1.TableWidget, { isShrink: widgetData.length <= 3, isLoading: isLoading, rows: widgetData.map((data) => ({
                id: `${data.text}`,
                content: (react_1.default.createElement(components_3.IconTextAndChartRow, { height: helpers_1.getRowHeight(widgetData.length), icon: data.icon, text: data.text, value: data.value, total: data.total, noDataText: noDataTexts[data.type] })),
                onClick: onRowClick ? () => onRowClick(data.type, periodValue.id) : undefined,
            })) }) }));
};
exports.WorkloadsDashboardWidget = WorkloadsDashboardWidget;
//# sourceMappingURL=WorkloadsDashboardWidget.js.map